// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from './../commonApi';
import { convertFromKopToRub } from '../pure/unitConversions';

const baseUrl = 'budgetAnalysis';
const budgetAnalysis = new CommonApi(baseUrl, 'Анализ затрат');

export const getExpenseDirectionInfo = async (params) => {
  const expenseDirectionInfo = await fetchRequest.get(
    `/${baseUrl}/getExpenseDirectionInfo`,
    params
  );
  if (expenseDirectionInfo)
  return expenseDirectionInfo.map((value) => ({
    ...value,
    sum: convertFromKopToRub(value.sum)
  }));
  throw new Error('Не удалось загрузить информацию');
};

export default {
  ...budgetAnalysis,
  getExpenseDirectionInfo
};
